import React, { useEffect } from 'react';
import styles from '../About/About.module.css'
import { FaCar, FaTools, FaUsers, FaAward } from 'react-icons/fa';

const About = () => {
      useEffect(() => {
    document.body.classList.add('about-page');
    return () => {
      document.body.classList.remove('about-page');
    };
  }, []);
  return (
    <div className={styles.aboutContainer}>
      {/* Hero Section */}
      <div className={styles.heroSection}>
        <h1>About KARZONE</h1>
        <p>Your Trusted Partner in Premium Car Services</p>
      </div>

      {/* Story Section */}
      <section className={styles.storySection}>
        <div className={styles.content}>
          <h2>Our Story</h2>
          <p>Since 2010, KARZONE has been at the forefront of automotive excellence. 
             We started with a simple mission: to provide unparalleled car services 
             with transparency, expertise, and dedication.</p>
        </div>
      </section>

      {/* Stats Section */}
      <section className={styles.statsSection}>
        <div className={styles.statCard}>
          <FaCar className={styles.icon} />
          <h3>15,000+</h3>
          <p>Cars Serviced</p>
        </div>
        <div className={styles.statCard}>
          <FaUsers className={styles.icon} />
          <h3>10,000+</h3>
          <p>Happy Clients</p>
        </div>
        <div className={styles.statCard}>
          <FaTools className={styles.icon} />
          <h3>50+</h3>
          <p>Expert Mechanics</p>
        </div>
        <div className={styles.statCard}>
          <FaAward className={styles.icon} />
          <h3>15+</h3>
          <p>Years Experience</p>
        </div>
      </section>

      {/* Values Section */}
      <section className={styles.valuesSection}>
        <h2>Our Core Values</h2>
        <div className={styles.valuesGrid}>
          <div className={styles.valueCard}>
            <h3>Excellence</h3>
            <p>We strive for perfection in every service we provide</p>
          </div>
          <div className={styles.valueCard}>
            <h3>Integrity</h3>
            <p>Honest and transparent in all our dealings</p>
          </div>
          <div className={styles.valueCard}>
            <h3>Innovation</h3>
            <p>Embracing the latest automotive technologies</p>
          </div>
          <div className={styles.valueCard}>
            <h3>Customer First</h3>
            <p>Your satisfaction is our top priority</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;